// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root"};